const BaseListEditFrmHtml = `
<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>

  <div *ngIf="isPageReady && entities" class="h-full">

    <div class="flex flex-col h-full">
      <div class="flex ml-2 mt-2 mb-3" >
        <button  (click)="onAdd()" pButton type="button" label="Add {{ entityTypeDisplayName}}" icon="pi pi-plus"
          class="p-button-sm" [disabled]="isAddDisabled()"></button>
        <span style="margin-left:10px; padding-top:7px; font-size:small; font-variant: small-caps; color: red;">{{statusMessage()}}</span>
        <div class="grow"></div>
        <button *ngIf="hasHelp" pButton (click)="showHelp()" class="p-button-rounded p-button-text" icon="pi pi-question-circle"></button>
      </div>

      <div class="grow h-full">
          <prox-ag-grid gridId="entitiesGrid" [gridOptions]="gridOptions"  [rowData]="entities">
          </prox-ag-grid>
      </div>
      <div *ngIf="showSaveBar">
        <prox-save-cancel class="mt-2" [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()" [isReadOnly]="isAddDisabled()"></prox-save-cancel>
      </div>
    </div>

  </div>
</ng-template>
`;
export default BaseListEditFrmHtml;
